import styled from '@emotion/styled';

import { COLOR_TEXT_PRIMARY } from './utils/variables';

export const CheckboxField = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: ${COLOR_TEXT_PRIMARY};
  cursor: pointer;
  user-select: none;
  width: fit-content;
`;
